import { TicketType } from "webshop-api";
import { ArrayHelper } from "webshop-modules/helper/Array.helper";

/**
 * TicketTypeMaximumAmountProvider
 */
export class TicketTypeMaximumAmountProvider {

    /**
     * whatItDoes
     * provides maximum amount of available tickets for provided ticketType
     */
    public static getMaximumFor(ticketType: TicketType, applicationMaximum: number): number {
        if (!ticketType) {
            throw new Error('Could not get maximum amounts for missing TicketType!');
        }

        if (applicationMaximum === undefined || applicationMaximum === null) {
            throw new Error('Could not get maximum amounts for not provided application ticket maximum!');
        }

        const maximum = [ applicationMaximum ];

        if (ticketType.maxTicketsPerOrder !== undefined) {
            maximum.push(ticketType.maxTicketsPerOrder);
        }

        if (ticketType.maxSellableTicketsLeft !== undefined) {
            maximum.push(ticketType.maxSellableTicketsLeft);
        }

        return maximum.reduce(ArrayHelper.ToLowestValue, Number.MAX_SAFE_INTEGER);
    }

}
